export const exampleData = () => {
  return {
    tryall: {
      request: {
        begin: '2019-04-08',
        end: '2019-07-01',
        granularity: 'week',
      },
      response: {
        valid: [
          {count: 60287, date: '2019-04-08'},
          {count: 66171, date: '2019-04-15'},
          {count: 75211, date: '2019-04-22'},
          {count: 70737, date: '2019-04-29'},
          {count: 76217, date: '2019-05-06'},
          {count: 83155, date: '2019-05-13'},
          {count: 76710, date: '2019-05-20'},
          {count: 89146, date: '2019-05-27'},
          {count: 88758, date: '2019-06-03'},
          {count: 104855, date: '2019-06-10'},
          {count: 113892, date: '2019-06-17'},
          {count: 121824, date: '2019-06-24'},
          {count: 139372, date: '2019-07-01'},
        ],
        overall: {
          sinceTime: '2019-04-08',
          untilTime: '2019-07-01',
          avgNewCount: 89718,
          totalCount: 1166335,
        },
        data: [
          {count: 60287, date: '2019-04-08'},
          {count: 66171, date: '2019-04-15'},
          {count: 75211, date: '2019-04-22'},
          {count: 70737, date: '2019-04-29'},
          {count: 76217, date: '2019-05-06'},
          {count: 83155, date: '2019-05-13'},
          {count: 76710, date: '2019-05-20'},
          {count: 89146, date: '2019-05-27'},
          {count: 88758, date: '2019-06-03'},
          {count: 104855, date: '2019-06-10'},
          {count: 113892, date: '2019-06-17'},
          {count: 121824, date: '2019-06-24'},
          {count: 139372, date: '2019-07-01'},
        ],
        results: [
          {
            total: 369356,
            skuType: 'Blush',
            data: [
              {count: 18848, date: '2019-04-08'},
              {count: 21232, date: '2019-04-15'},
              {count: 23963, date: '2019-04-22'},
              {count: 22124, date: '2019-04-29'},
              {count: 23842, date: '2019-05-06'},
              {count: 26017, date: '2019-05-13'},
              {count: 23889, date: '2019-05-20'},
              {count: 27895, date: '2019-05-27'},
              {count: 27686, date: '2019-06-03'},
              {count: 33676, date: '2019-06-10'},
              {count: 36583, date: '2019-06-17'},
              {count: 39134, date: '2019-06-24'},
              {count: 44466, date: '2019-07-01'},
            ],
          },
          {
            total: 249161,
            skuType: 'EyeLiner',
            data: [
              {count: 12955, date: '2019-04-08'},
              {count: 14049, date: '2019-04-15'},
              {count: 16022, date: '2019-04-22'},
              {count: 15198, date: '2019-04-29'},
              {count: 16374, date: '2019-05-06'},
              {count: 17863, date: '2019-05-13'},
              {count: 16513, date: '2019-05-20'},
              {count: 19149, date: '2019-05-27'},
              {count: 19093, date: '2019-06-03'},
              {count: 22253, date: '2019-06-10'},
              {count: 24169, date: '2019-06-17'},
              {count: 25851, date: '2019-06-24'},
              {count: 29671, date: '2019-07-01'},
            ],
          },
          {
            total: 190370,
            skuType: 'EyeShadow',
            data: [
              {count: 9898, date: '2019-04-08'},
              {count: 10734, date: '2019-04-15'},
              {count: 12241, date: '2019-04-22'},
              {count: 11612, date: '2019-04-29'},
              {count: 12511, date: '2019-05-06'},
              {count: 13648, date: '2019-05-13'},
              {count: 12617, date: '2019-05-20'},
              {count: 14631, date: '2019-05-27'},
              {count: 14588, date: '2019-06-03'},
              {count: 17002, date: '2019-06-10'},
              {count: 18466, date: '2019-06-17'},
              {count: 19752, date: '2019-06-24'},
              {count: 22670, date: '2019-07-01'},
            ],
          },
          {
            total: 357448,
            skuType: 'Lipstick',
            data: [
              {count: 18586, date: '2019-04-08'},
              {count: 20155, date: '2019-04-15'},
              {count: 22985, date: '2019-04-22'},
              {count: 21803, date: '2019-04-29'},
              {count: 23491, date: '2019-05-06'},
              {count: 25627, date: '2019-05-13'},
              {count: 23690, date: '2019-05-20'},
              {count: 27471, date: '2019-05-27'},
              {count: 27391, date: '2019-06-03'},
              {count: 31924, date: '2019-06-10'},
              {count: 34673, date: '2019-06-17'},
              {count: 37086, date: '2019-06-24'},
              {count: 42566, date: '2019-07-01'},
            ],
          },
        ],
      },
    },
    trylive: {
      request: {
        begin: '2019-04-08',
        end: '2019-07-01',
        granularity: 'week',
      },
      response: {
        valid: [
          {count: 27048, date: '2019-04-08'},
          {count: 30122, date: '2019-04-15'},
          {count: 34233, date: '2019-04-22'},
          {count: 31737, date: '2019-04-29'},
          {count: 34196, date: '2019-05-06'},
          {count: 37308, date: '2019-05-13'},
          {count: 34416, date: '2019-05-20'},
          {count: 39996, date: '2019-05-27'},
          {count: 39822, date: '2019-06-03'},
          {count: 47732, date: '2019-06-10'},
          {count: 51846, date: '2019-06-17'},
          {count: 55457, date: '2019-06-24'},
          {count: 63438, date: '2019-07-01'},
        ],
        overall: {
          sinceTime: '2019-04-08',
          untilTime: '2019-07-01',
          avgNewCount: 40566,
          totalCount: 527352,
        },
        data: [
          {count: 27048, date: '2019-04-08'},
          {count: 30122, date: '2019-04-15'},
          {count: 34233, date: '2019-04-22'},
          {count: 31737, date: '2019-04-29'},
          {count: 34196, date: '2019-05-06'},
          {count: 37308, date: '2019-05-13'},
          {count: 34416, date: '2019-05-20'},
          {count: 39996, date: '2019-05-27'},
          {count: 39822, date: '2019-06-03'},
          {count: 47732, date: '2019-06-10'},
          {count: 51846, date: '2019-06-17'},
          {count: 55457, date: '2019-06-24'},
          {count: 63438, date: '2019-07-01'},
        ],
        results: [
          {
            total: 170464,
            skuType: 'Blush',
            data: [
              {count: 8492, date: '2019-04-08'},
              {count: 9998, date: '2019-04-15'},
              {count: 11284, date: '2019-04-22'},
              {count: 9968, date: '2019-04-29'},
              {count: 10742, date: '2019-05-06'},
              {count: 11722, date: '2019-05-13'},
              {count: 10763, date: '2019-05-20'},
              {count: 12568, date: '2019-05-27'},
              {count: 12474, date: '2019-06-03'},
              {count: 15858, date: '2019-06-10'},
              {count: 17227, date: '2019-06-17'},
              {count: 18428, date: '2019-06-24'},
              {count: 20939, date: '2019-07-01'},
            ],
          },
          {
            total: 109183,
            skuType: 'EyeLiner',
            data: [
              {count: 5677, date: '2019-04-08'},
              {count: 6156, date: '2019-04-15'},
              {count: 7021, date: '2019-04-22'},
              {count: 6660, date: '2019-04-29'},
              {count: 7175, date: '2019-05-06'},
              {count: 7828, date: '2019-05-13'},
              {count: 7236, date: '2019-05-20'},
              {count: 8391, date: '2019-05-27'},
              {count: 8367, date: '2019-06-03'},
              {count: 9751, date: '2019-06-10'},
              {count: 10591, date: '2019-06-17'},
              {count: 11328, date: '2019-06-24'},
              {count: 13002, date: '2019-07-01'},
            ],
          },
          {
            total: 78388,
            skuType: 'EyeShadow',
            data: [
              {count: 4076, date: '2019-04-08'},
              {count: 4420, date: '2019-04-15'},
              {count: 5041, date: '2019-04-22'},
              {count: 4781, date: '2019-04-29'},
              {count: 5151, date: '2019-05-06'},
              {count: 5620, date: '2019-05-13'},
              {count: 5195, date: '2019-05-20'},
              {count: 6024, date: '2019-05-27'},
              {count: 6007, date: '2019-06-03'},
              {count: 7001, date: '2019-06-10'},
              {count: 7604, date: '2019-06-17'},
              {count: 8133, date: '2019-06-24'},
              {count: 9335, date: '2019-07-01'},
            ],
          },
          {
            total: 169318,
            skuType: 'Lipstick',
            data: [
              {count: 8804, date: '2019-04-08'},
              {count: 9547, date: '2019-04-15'},
              {count: 10888, date: '2019-04-22'},
              {count: 10328, date: '2019-04-29'},
              {count: 11127, date: '2019-05-06'},
              {count: 12139, date: '2019-05-13'},
              {count: 11222, date: '2019-05-20'},
              {count: 13013, date: '2019-05-27'},
              {count: 12975, date: '2019-06-03'},
              {count: 15122, date: '2019-06-10'},
              {count: 16424, date: '2019-06-17'},
              {count: 17567, date: '2019-06-24'},
              {count: 20163, date: '2019-07-01'},
            ],
          },
        ],
      },
    },
    tryphoto: {
      request: {
        begin: '2019-04-08',
        end: '2019-07-01',
        granularity: 'week',
      },
      response: {
        valid: [
          {count: 33239, date: '2019-04-08'},
          {count: 36049, date: '2019-04-15'},
          {count: 40978, date: '2019-04-22'},
          {count: 39000, date: '2019-04-29'},
          {count: 42022, date: '2019-05-06'},
          {count: 45847, date: '2019-05-13'},
          {count: 42294, date: '2019-05-20'},
          {count: 49150, date: '2019-05-27'},
          {count: 48936, date: '2019-06-03'},
          {count: 57123, date: '2019-06-10'},
          {count: 62046, date: '2019-06-17'},
          {count: 66367, date: '2019-06-24'},
          {count: 75934, date: '2019-07-01'},
        ],
        overall: {
          sinceTime: '2019-04-08',
          untilTime: '2019-07-01',
          avgNewCount: 49153,
          totalCount: 638983,
        },
        data: [
          {count: 33239, date: '2019-04-08'},
          {count: 36049, date: '2019-04-15'},
          {count: 40978, date: '2019-04-22'},
          {count: 39000, date: '2019-04-29'},
          {count: 42022, date: '2019-05-06'},
          {count: 45847, date: '2019-05-13'},
          {count: 42294, date: '2019-05-20'},
          {count: 49150, date: '2019-05-27'},
          {count: 48936, date: '2019-06-03'},
          {count: 57123, date: '2019-06-10'},
          {count: 62046, date: '2019-06-17'},
          {count: 66367, date: '2019-06-24'},
          {count: 75934, date: '2019-07-01'},
        ],
        results: [
          {
            total: 198892,
            skuType: 'Blush',
            data: [
              {count: 10356, date: '2019-04-08'},
              {count: 11234, date: '2019-04-15'},
              {count: 12679, date: '2019-04-22'},
              {count: 12156, date: '2019-04-29'},
              {count: 13100, date: '2019-05-06'},
              {count: 14295, date: '2019-05-13'},
              {count: 13126, date: '2019-05-20'},
              {count: 15327, date: '2019-05-27'},
              {count: 15212, date: '2019-06-03'},
              {count: 17818, date: '2019-06-10'},
              {count: 19356, date: '2019-06-17'},
              {count: 20706, date: '2019-06-24'},
              {count: 23527, date: '2019-07-01'},
            ],
          },
          {
            total: 139978,
            skuType: 'EyeLiner',
            data: [
              {count: 7278, date: '2019-04-08'},
              {count: 7893, date: '2019-04-15'},
              {count: 9001, date: '2019-04-22'},
              {count: 8538, date: '2019-04-29'},
              {count: 9199, date: '2019-05-06'},
              {count: 10036, date: '2019-05-13'},
              {count: 9277, date: '2019-05-20'},
              {count: 10758, date: '2019-05-27'},
              {count: 10726, date: '2019-06-03'},
              {count: 12502, date: '2019-06-10'},
              {count: 13578, date: '2019-06-17'},
              {count: 14523, date: '2019-06-24'},
              {count: 16669, date: '2019-07-01'},
            ],
          },
          {
            total: 111982,
            skuType: 'EyeShadow',
            data: [
              {count: 5823, date: '2019-04-08'},
              {count: 6314, date: '2019-04-15'},
              {count: 7201, date: '2019-04-22'},
              {count: 6831, date: '2019-04-29'},
              {count: 7359, date: '2019-05-06'},
              {count: 8028, date: '2019-05-13'},
              {count: 7422, date: '2019-05-20'},
              {count: 8606, date: '2019-05-27'},
              {count: 8581, date: '2019-06-03'},
              {count: 10001, date: '2019-06-10'},
              {count: 10863, date: '2019-06-17'},
              {count: 11619, date: '2019-06-24'},
              {count: 13335, date: '2019-07-01'},
            ],
          },
          {
            total: 188131,
            skuType: 'Lipstick',
            data: [
              {count: 9782, date: '2019-04-08'},
              {count: 10608, date: '2019-04-15'},
              {count: 12097, date: '2019-04-22'},
              {count: 11475, date: '2019-04-29'},
              {count: 12363, date: '2019-05-06'},
              {count: 13488, date: '2019-05-13'},
              {count: 12469, date: '2019-05-20'},
              {count: 14459, date: '2019-05-27'},
              {count: 14416, date: '2019-06-03'},
              {count: 16802, date: '2019-06-10'},
              {count: 18249, date: '2019-06-17'},
              {count: 19519, date: '2019-06-24'},
              {count: 22403, date: '2019-07-01'},
            ],
          },
        ],
      },
    },
    saveall: {
      request: {
        begin: '2019-04-08',
        end: '2019-07-01',
        granularity: 'week',
      },
      response: {
        valid: [
          {count: 571, date: '2019-04-08'},
          {count: 603, date: '2019-04-15'},
          {count: 634, date: '2019-04-22'},
          {count: 639, date: '2019-04-29'},
          {count: 681, date: '2019-05-06'},
          {count: 826, date: '2019-05-13'},
          {count: 750, date: '2019-05-20'},
          {count: 783, date: '2019-05-27'},
          {count: 726, date: '2019-06-03'},
          {count: 860, date: '2019-06-10'},
          {count: 1013, date: '2019-06-17'},
          {count: 1064, date: '2019-06-24'},
          {count: 1200, date: '2019-07-01'},
        ],
        overall: {
          sinceTime: '2019-04-08',
          untilTime: '2019-07-01',
          avgNewCount: 796,
          totalCount: 10349,
        },
        data: [
          {count: 571, date: '2019-04-08'},
          {count: 603, date: '2019-04-15'},
          {count: 634, date: '2019-04-22'},
          {count: 639, date: '2019-04-29'},
          {count: 681, date: '2019-05-06'},
          {count: 826, date: '2019-05-13'},
          {count: 750, date: '2019-05-20'},
          {count: 783, date: '2019-05-27'},
          {count: 726, date: '2019-06-03'},
          {count: 860, date: '2019-06-10'},
          {count: 1013, date: '2019-06-17'},
          {count: 1064, date: '2019-06-24'},
          {count: 1200, date: '2019-07-01'},
        ],
        results: [
          {
            total: 4052,
            skuType: 'Blush',
            data: [
              {count: 226, date: '2019-04-08'},
              {count: 236, date: '2019-04-15'},
              {count: 260, date: '2019-04-22'},
              {count: 267, date: '2019-04-29'},
              {count: 286, date: '2019-05-06'},
              {count: 310, date: '2019-05-13'},
              {count: 287, date: '2019-05-20'},
              {count: 292, date: '2019-05-27'},
              {count: 290, date: '2019-06-03'},
              {count: 339, date: '2019-06-10'},
              {count: 405, date: '2019-06-17'},
              {count: 397, date: '2019-06-24'},
              {count: 458, date: '2019-07-01'},
            ],
          },
          {
            total: 1193,
            skuType: 'EyeLiner',
            data: [
              {count: 66, date: '2019-04-08'},
              {count: 54, date: '2019-04-15'},
              {count: 56, date: '2019-04-22'},
              {count: 60, date: '2019-04-29'},
              {count: 66, date: '2019-05-06'},
              {count: 114, date: '2019-05-13'},
              {count: 98, date: '2019-05-20'},
              {count: 110, date: '2019-05-27'},
              {count: 82, date: '2019-06-03'},
              {count: 108, date: '2019-06-10'},
              {count: 116, date: '2019-06-17'},
              {count: 126, date: '2019-06-24'},
              {count: 137, date: '2019-07-01'},
            ],
          },
          {
            total: 1076,
            skuType: 'EyeShadow',
            data: [
              {count: 57, date: '2019-04-08'},
              {count: 50, date: '2019-04-15'},
              {count: 52, date: '2019-04-22'},
              {count: 56, date: '2019-04-29'},
              {count: 54, date: '2019-05-06'},
              {count: 104, date: '2019-05-13'},
              {count: 90, date: '2019-05-20'},
              {count: 101, date: '2019-05-27'},
              {count: 76, date: '2019-06-03'},
              {count: 87, date: '2019-06-10'},
              {count: 98, date: '2019-06-17'},
              {count: 121, date: '2019-06-24'},
              {count: 130, date: '2019-07-01'},
            ],
          },
          {
            total: 4029,
            skuType: 'Lipstick',
            data: [
              {count: 222, date: '2019-04-08'},
              {count: 263, date: '2019-04-15'},
              {count: 266, date: '2019-04-22'},
              {count: 256, date: '2019-04-29'},
              {count: 275, date: '2019-05-06'},
              {count: 298, date: '2019-05-13'},
              {count: 275, date: '2019-05-20'},
              {count: 280, date: '2019-05-27'},
              {count: 278, date: '2019-06-03'},
              {count: 326, date: '2019-06-10'},
              {count: 395, date: '2019-06-17'},
              {count: 421, date: '2019-06-24'},
              {count: 475, date: '2019-07-01'},
            ],
          },
        ],
      },
    },
    savelive: {
      request: {
        begin: '2019-04-08',
        end: '2019-07-01',
        granularity: 'week',
      },
      response: {
        valid: [
          {count: 282, date: '2019-04-08'},
          {count: 282, date: '2019-04-15'},
          {count: 307, date: '2019-04-22'},
          {count: 319, date: '2019-04-29'},
          {count: 339, date: '2019-05-06'},
          {count: 412, date: '2019-05-13'},
          {count: 374, date: '2019-05-20'},
          {count: 391, date: '2019-05-27'},
          {count: 362, date: '2019-06-03'},
          {count: 429, date: '2019-06-10'},
          {count: 500, date: '2019-06-17'},
          {count: 508, date: '2019-06-24'},
          {count: 578, date: '2019-07-01'},
        ],
        overall: {
          sinceTime: '2019-04-08',
          untilTime: '2019-07-01',
          avgNewCount: 391,
          totalCount: 5082,
        },
        data: [
          {count: 282, date: '2019-04-08'},
          {count: 282, date: '2019-04-15'},
          {count: 307, date: '2019-04-22'},
          {count: 319, date: '2019-04-29'},
          {count: 339, date: '2019-05-06'},
          {count: 412, date: '2019-05-13'},
          {count: 374, date: '2019-05-20'},
          {count: 391, date: '2019-05-27'},
          {count: 362, date: '2019-06-03'},
          {count: 429, date: '2019-06-10'},
          {count: 500, date: '2019-06-17'},
          {count: 508, date: '2019-06-24'},
          {count: 578, date: '2019-07-01'},
        ],
        results: [
          {
            total: 1953,
            skuType: 'Blush',
            data: [
              {count: 110, date: '2019-04-08'},
              {count: 99, date: '2019-04-15'},
              {count: 121, date: '2019-04-22'},
              {count: 134, date: '2019-04-29'},
              {count: 143, date: '2019-05-06'},
              {count: 155, date: '2019-05-13'},
              {count: 143, date: '2019-05-20'},
              {count: 146, date: '2019-05-27'},
              {count: 145, date: '2019-06-03'},
              {count: 170, date: '2019-06-10'},
              {count: 199, date: '2019-06-17'},
              {count: 178, date: '2019-06-24'},
              {count: 211, date: '2019-07-01'},
            ],
          },
          {
            total: 576,
            skuType: 'EyeLiner',
            data: [
              {count: 32, date: '2019-04-08'},
              {count: 26, date: '2019-04-15'},
              {count: 27, date: '2019-04-22'},
              {count: 29, date: '2019-04-29'},
              {count: 32, date: '2019-05-06'},
              {count: 56, date: '2019-05-13'},
              {count: 48, date: '2019-05-20'},
              {count: 54, date: '2019-05-27'},
              {count: 40, date: '2019-06-03'},
              {count: 53, date: '2019-06-10'},
              {count: 55, date: '2019-06-17'},
              {count: 59, date: '2019-06-24'},
              {count: 65, date: '2019-07-01'},
            ],
          },
          {
            total: 538,
            skuType: 'EyeShadow',
            data: [
              {count: 29, date: '2019-04-08'},
              {count: 25, date: '2019-04-15'},
              {count: 26, date: '2019-04-22'},
              {count: 28, date: '2019-04-29'},
              {count: 27, date: '2019-05-06'},
              {count: 52, date: '2019-05-13'},
              {count: 45, date: '2019-05-20'},
              {count: 50, date: '2019-05-27'},
              {count: 38, date: '2019-06-03'},
              {count: 43, date: '2019-06-10'},
              {count: 49, date: '2019-06-17'},
              {count: 60, date: '2019-06-24'},
              {count: 65, date: '2019-07-01'},
            ],
          },
          {
            total: 2014,
            skuType: 'Lipstick',
            data: [
              {count: 111, date: '2019-04-08'},
              {count: 131, date: '2019-04-15'},
              {count: 133, date: '2019-04-22'},
              {count: 128, date: '2019-04-29'},
              {count: 137, date: '2019-05-06'},
              {count: 149, date: '2019-05-13'},
              {count: 138, date: '2019-05-20'},
              {count: 140, date: '2019-05-27'},
              {count: 139, date: '2019-06-03'},
              {count: 163, date: '2019-06-10'},
              {count: 197, date: '2019-06-17'},
              {count: 210, date: '2019-06-24'},
              {count: 237, date: '2019-07-01'},
            ],
          },
        ],
      },
    },
    savephoto: {
      request: {
        begin: '2019-04-08',
        end: '2019-07-01',
        granularity: 'week',
      },
      response: {
        valid: [
          {count: 289, date: '2019-04-08'},
          {count: 321, date: '2019-04-15'},
          {count: 327, date: '2019-04-22'},
          {count: 321, date: '2019-04-29'},
          {count: 341, date: '2019-05-06'},
          {count: 414, date: '2019-05-13'},
          {count: 376, date: '2019-05-20'},
          {count: 393, date: '2019-05-27'},
          {count: 364, date: '2019-06-03'},
          {count: 431, date: '2019-06-10'},
          {count: 513, date: '2019-06-17'},
          {count: 557, date: '2019-06-24'},
          {count: 621, date: '2019-07-01'},
        ],
        overall: {
          sinceTime: '2019-04-08',
          untilTime: '2019-07-01',
          avgNewCount: 405,
          totalCount: 5268,
        },
        data: [
          {count: 289, date: '2019-04-08'},
          {count: 321, date: '2019-04-15'},
          {count: 327, date: '2019-04-22'},
          {count: 321, date: '2019-04-29'},
          {count: 341, date: '2019-05-06'},
          {count: 414, date: '2019-05-13'},
          {count: 376, date: '2019-05-20'},
          {count: 393, date: '2019-05-27'},
          {count: 364, date: '2019-06-03'},
          {count: 431, date: '2019-06-10'},
          {count: 513, date: '2019-06-17'},
          {count: 557, date: '2019-06-24'},
          {count: 621, date: '2019-07-01'},
        ],
        results: [
          {
            total: 2098,
            skuType: 'Blush',
            data: [
              {count: 116, date: '2019-04-08'},
              {count: 137, date: '2019-04-15'},
              {count: 139, date: '2019-04-22'},
              {count: 134, date: '2019-04-29'},
              {count: 143, date: '2019-05-06'},
              {count: 155, date: '2019-05-13'},
              {count: 143, date: '2019-05-20'},
              {count: 146, date: '2019-05-27'},
              {count: 145, date: '2019-06-03'},
              {count: 170, date: '2019-06-10'},
              {count: 206, date: '2019-06-17'},
              {count: 219, date: '2019-06-24'},
              {count: 247, date: '2019-07-01'},
            ],
          },
          {
            total: 617,
            skuType: 'EyeLiner',
            data: [
              {count: 34, date: '2019-04-08'},
              {count: 28, date: '2019-04-15'},
              {count: 29, date: '2019-04-22'},
              {count: 31, date: '2019-04-29'},
              {count: 34, date: '2019-05-06'},
              {count: 58, date: '2019-05-13'},
              {count: 50, date: '2019-05-20'},
              {count: 56, date: '2019-05-27'},
              {count: 42, date: '2019-06-03'},
              {count: 55, date: '2019-06-10'},
              {count: 61, date: '2019-06-17'},
              {count: 67, date: '2019-06-24'},
              {count: 72, date: '2019-07-01'},
            ],
          },
          {
            total: 538,
            skuType: 'EyeShadow',
            data: [
              {count: 29, date: '2019-04-08'},
              {count: 25, date: '2019-04-15'},
              {count: 26, date: '2019-04-22'},
              {count: 28, date: '2019-04-29'},
              {count: 27, date: '2019-05-06'},
              {count: 52, date: '2019-05-13'},
              {count: 45, date: '2019-05-20'},
              {count: 50, date: '2019-05-27'},
              {count: 38, date: '2019-06-03'},
              {count: 43, date: '2019-06-10'},
              {count: 49, date: '2019-06-17'},
              {count: 60, date: '2019-06-24'},
              {count: 65, date: '2019-07-01'},
            ],
          },
          {
            total: 2014,
            skuType: 'Lipstick',
            data: [
              {count: 111, date: '2019-04-08'},
              {count: 131, date: '2019-04-15'},
              {count: 133, date: '2019-04-22'},
              {count: 128, date: '2019-04-29'},
              {count: 137, date: '2019-05-06'},
              {count: 149, date: '2019-05-13'},
              {count: 138, date: '2019-05-20'},
              {count: 140, date: '2019-05-27'},
              {count: 139, date: '2019-06-03'},
              {count: 163, date: '2019-06-10'},
              {count: 197, date: '2019-06-17'},
              {count: 210, date: '2019-06-24'},
              {count: 237, date: '2019-07-01'},
            ],
          },
        ],
      },
    },
  };
};
